import { apiFetch } from './api';

export type BillingInterval = 'month' | 'year';

export async function startSubscriptionCheckout(
  planId: string,
  interval: BillingInterval,
  quantity = 1,
): Promise<void> {
  const response = await apiFetch('/api/stripe/create-checkout-session', {
    method: 'POST',
    body: { planId, interval, quantity },
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data?.url) {
    const message =
      data?.message || data?.error || 'Unable to start checkout. Please try again or talk to sales.';
    throw new Error(message);
  }

  window.location.assign(data.url);
}

/** One-time Checkout for 1,000 contacts this month. Not a subscription. */
export async function startContactPackCheckout(): Promise<void> {
  const response = await apiFetch('/api/stripe/create-contact-pack-checkout', {
    method: 'POST',
    body: {},
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data?.url) {
    const message =
      data?.message || data?.error || 'Unable to start checkout. Please try again or talk to sales.';
    throw new Error(message);
  }

  window.location.assign(data.url);
}

/** Opens Stripe Customer Portal for invoices, payment method, and cancel. */
export async function openBillingPortal(): Promise<void> {
  const response = await apiFetch('/api/stripe/create-portal-session', {
    method: 'POST',
    body: {},
  });
  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data?.url) {
    const message =
      data?.message || data?.error || 'Unable to open billing portal. Please try again or talk to sales.';
    throw new Error(message);
  }

  window.location.assign(data.url);
}
